import styled, { css } from "styled-components";

export const Mask = styled.div`
	position: fixed;
	top: 0px;
	left: 0px;
	height: 100%;
	width: 100%;
	background: rgba(0,0,0,0.7);
	z-index: 50;
	display: flex;
	align-items: flex-end;
	justify-content: center;
	animation: fadeInBackground 300ms ease;
	
	@media (min-width: 768px) {
		align-items: center;
	}
	
	@keyframes fadeInBackground {
		from {
			background: rgba(0,0,0,0);
		}
		to {
			background: rgba(0,0,0,0.7);
		}
	}
`

export const Container = styled.div`
	position: relative;
	height: auto;
	width: 100%;
	max-width: 100%;
	max-height: 90vh;
	overflow-y: auto;
	background: #fff;
	border-top-left-radius: 16px;
	border-top-right-radius: 16px;
	display: flex;
	flex-direction: column;
	animation: slideUp 350ms cubic-bezier(0.16, 1, 0.3, 1);
	transform-origin: bottom center;

	@media (min-width: 768px) {
		max-width: 440px;
		border-radius: 16px;
		animation: fadeIn 300ms both;
		transform-origin: center;
		
		@keyframes fadeIn {
			from {
				opacity: 0;
				transform: scale(0.95);
			}
			to {
				opacity: 1;
				transform: scale(1);
			}
		}
	}

	@keyframes slideUp {
		from {
			transform: translateY(100%);
		}
		to {
			transform: translateY(0);
		}
	}
	
	.header{
		padding: 24px 24px;
		p{
			font-weight: bold;
		}
	}
	.close-modal{
		position: absolute;
		top: 4px;
		right: 4px;
		background: none;
		border: none;
		appearance: none;
		padding: 16px;
		cursor: pointer;
		z-index: 2;
		&:hover{
			opacity: 0.7;
		}
	}

	.container-card{
		z-index: 2;
		position: relative;
		border-radius: 6px;
		border: 1px solid ${({ theme }) => theme.COLORS.GRAY_200};
		margin: 0px 24px;
		display: flex;
		box-shadow: 0px 2px 8px rgba(0,0,0,0.05);
		background: #fff;

		.percent-discount{
			position: absolute;
			z-index: 10;
			top: 0px;
			right: 0px;
			height: 38px;
			width: 38px;
			background: red;
			border-radius: 50%;
			transform: translate(10px, -15px);
			align-items: center;
			justify-content: center;
			display: flex;
			p{
				color: #fff;
				font-weight: 600;
				font-size: 1.2rem;
			}
		}
	
		img{
			width: 30%;
			object-fit: cover;
			border-bottom-left-radius: 6px;
			border-top-left-radius: 6px;
		}
		.infos-container{
			display: flex;
			flex-direction: column;
			padding: 8px 0px 8px 16px; 
			.product-title{
				font-weight: bold;
				margin-bottom: 8px;
			} 
			.end-offer{
				font-size: 1.2rem;
			}
			.old-price{
				${({ theme }) => css`
						color: ${theme.COLORS.GRAY_700};
						margin-top: 16px;
						text-decoration: line-through;
						font-size: 1.2rem;
				`}
			}
			.new-price{
				${({ theme }) => css`
						color: ${theme.COLORS.GREEN};
						font-weight: ${theme.FONT_WEIGHT.BOLD};
						margin-top: 4px;
				`}
			}
		}
	}

	.name-location-container{
		display: flex;
		z-index: 1;
		flex-direction: column;
		background: rgba(0,0,0,.05);
		padding: 24px 24px 16px 24px;
		opacity: 0.8;
		margin: 0px 32px;
		border-radius: 6px;
		transform: translate(0px,-10px);
		.shop-name{
			font-weight: bold;
		}
		p{
			font-size: 1.4rem;
			margin-top: 4px;
		}
	}
	.title-book-product{
		font-weight: bold;
		padding: 0px 24px 8px 24px;
		margin-top: 24px;
	}
	.send-zap{
		padding: 16px 24px;
		margin: 0px 24px 24px;
		cursor: pointer;
		background: ${({ theme }) => theme.COLORS.GREEN};
		border: none;
		border-radius: 6px;
		color: #fff;
		font-weight: 500;
		font-size: 1.6rem;
	}
`;
